export const validUrlRegex = /^https?:\/\//;
export const validateUrl = (url, name, message=null) => {
    if (url === undefined || url === null || !url.trim().match(validUrlRegex)) {
        throw message ? message : `Please provide a valid ${name}. Example: https://membrz.club`;
    }
};